import Nullstack from 'nullstack';
export default function IconTransitionLeft({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-transition-left",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M6 21a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3"
  }), "   ", Nullstack.element("path", {
    d: "M21 6v12a3 3 0 0 1 -6 0v-12a3 3 0 0 1 6 0z"
  }), "   ", Nullstack.element("path", {
    d: "M15 12h-8"
  }), "   ", Nullstack.element("path", {
    d: "M10 9l-3 3l3 3"
  }), " ");
}